const FORM_SUBMIT_BY_LOGIN = 'FORM_SUBMIT_BY_LOGIN'
const FORM_SUBMIT_BY_LOGIN_SUCCESS = 'FORM_SUBMIT_BY_LOGIN_SUCCESS'

export { FORM_SUBMIT_BY_LOGIN, FORM_SUBMIT_BY_LOGIN_SUCCESS }
